/** GA4 Measurement ID — override with VITE_GA_MEASUREMENT_ID in .env for staging. */
export const GA_MEASUREMENT_ID =
  typeof import.meta !== 'undefined' && import.meta.env?.VITE_GA_MEASUREMENT_ID
    ? String(import.meta.env.VITE_GA_MEASUREMENT_ID)
    : 'G-RMQD1V5BKQ';

/**
 * GA hits should only run on the real Kiddoware site so local/preview/staging hosts
 * do not pollute production property data.
 */
export function shouldUseGoogleAnalytics(hostname) {
  const h = String(hostname ?? (typeof window !== 'undefined' ? window.location.hostname : ''))
    .toLowerCase()
    .trim();
  return h === 'kiddoware.com' || h.endsWith('.kiddoware.com');
}

/**
 * Privacy-first GA4 config applied to every gtag('config', …) call.
 *
 * This app serves children (ages 4–12). All tracking must be anonymous:
 * - No user_id or persistent identifiers are sent to GA.
 * - storage: 'none' prevents GA4 from writing any cookies or localStorage.
 *   Event counts still work; sessions are not stitched across page loads.
 * - anonymize_ip: masks IP address at collection (belt-and-suspenders with GA4's own masking).
 * - allow_google_signals: false — no cross-device demographics / interest data.
 * - allow_ad_personalization_signals: false — no ad targeting from this data.
 * - ads_data_redaction: true — strips ad click IDs (gclid etc.) from requests.
 * - restricted_data_processing: true — CCPA limited-data-use signal to Google.
 */
export const GA_GTAG_PRIVACY_OPTIONS = {
  anonymize_ip: true,
  allow_google_signals: false,
  allow_ad_personalization_signals: false,
  ads_data_redaction: true,
  restricted_data_processing: true,
  storage: 'none',
};
